import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInputEmail, setFormaPago } from 'src/reducer/action/pago'
import { getItemStepz, setItemStepz } from 'src/helpers/localstorage'
import { Col, Container, Form, Row } from 'react-bootstrap'
import FormaPagoCard from './FormaPagoCard'
import InfoIcon from 'src/assets/components/InfoIcon'
import ResumenPago from '../1-seleccionepoliza/ResumenPago'
import { useMediaQuery } from 'react-responsive'
// import { useNavigate } from 'react-router-dom';

const FormaPago = ({ step, stepForward, stepBackwards }) => {
  const dispatch = useDispatch()

  const { email } = useSelector(state => state.pago)
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [emailError, setEmailError] = useState(false);

  const seleccioneFormadePago = idFormaPago => {

    // validar si el email es valido 
  
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email || !emailRegex.test(email)) {
        setEmailError(false);              // reset animación
        setTimeout(() => setEmailError(true), 10);
        return;
      }


    setItemStepz({ pay: idFormaPago, email: email })

    // forma de pago redux
    dispatch(setFormaPago(idFormaPago))

    // step next
    stepForward(step)
  }

  const handleInputChange = e => {
    e.preventDefault()
    const { name, value } = e.target

    dispatch(setInputEmail({ name, value }))
  }

  return (
    <div className='formapago'>  
     {
      isMobile && (
         <div style={{ paddingBottom: '60px'  }}/>
      )
     }  
      <ResumenPago 
        step={step} 
        stepForward={stepForward} 
        stepBackwards={stepBackwards} 
        fixed={isMobile} 
      />
      <Container>
        <Row className='justify-content-md-center'>
          <Col md='5' lg='7'>
            <h5>
              {' '}
              <span
                style={{
                  background: '#E5F0FC',
                  borderRadius: '0.8em',
                  display: 'inline-block',
                  lineHeight: '1.6em',
                  marginRight: '6px',
                  textAlign: 'center',
                  width: '1.6em'
                }}
              >
                1
              </span>
              Correo electrónico
            </h5>
            {/* <Form.Label className='text-left h6 font-weight-bold'>Email</Form.Label> */}
            <Form.Control
              type='email'
              name='email'
              value={email}
              onChange={handleInputChange}
              className={`border border-2 btn-width-responsive ${
                emailError ? "input-error" : ""
              }`}              
             autoFocus
            />
            <span className='form-text pb-0 mb-0' style={{fontSize:'13px'}}>
              <InfoIcon height={13} width={13} style={{paddingBottom:'2px'}}/>
              Correo electrónico donde se enviara la confirmación de pago
            </span>
            <br />
            <br /> <br />
            <h5>
              <span
                style={{
                  background: '#E5F0FC',
                  borderRadius: '0.8em',
                  display: 'inline-block',
                  lineHeight: '1.6em',
                  marginRight: '6px',
                  textAlign: 'center',
                  width: '1.6em'
                }}
              >
                2
              </span>
              Forma de pago
            </h5>
            <FormaPagoCard
              selectPago={parseFloat(getItemStepz()?.pay)}
              onChangeSelectPago={seleccioneFormadePago}
            />
          </Col>
        </Row>
      </Container>
     <div style={{ paddingBottom: isMobile ? '170px' : '0' }}/>
    </div>
  )
}

export default FormaPago
